(ns admin.subscriptions.configuration
  (:require [re-frame.core :refer [reg-sub subscribe]]))

(reg-sub :configuration/configuration
         (fn [{:keys [configuration]}] configuration))

(reg-sub :configuration/kyber-base-url
         (fn [_ _] (subscribe [:configuration/configuration]))
         (fn [{:keys [kyber-base-url]} _] kyber-base-url))
